import React, { useState, useEffect } from 'react';
import { Text, Button, BackButton, Loading, MultiSelect } from 'ui';
import { updateCampaign, useCampaign, useAuth } from 'api';
import { useParams, useHistory } from 'react-router-dom';
import countries from 'config/countries';

export default function CampaignRegion(props) {
  
  const { campaignId } = useParams();
  const auth = useAuth();
  const history = useHistory();
  const campaign = useCampaign(auth ? auth.user.companyId : null, campaignId);
  
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  const [state, setState] = useState("");
  useEffect(() => {
    if(campaign) {
      setCountry(campaign.country || "");
      setRegion(campaign.region || "");
      setState(campaign.state || "");
    }
  }, [campaign]);
  
  async function save() {
    await updateCampaign(auth.user.companyId, campaignId, {
      country, 
      region,
      state,
    });
    history.push('view');
  }
  
  async function skip() {
    await updateCampaign(auth.user.companyId, campaignId, {
      allRegions: true,
    });
    history.push('view');
  }
  
  if(!campaign) {
    return <Loading/>;
  }
  
  let states = [];
  let regions = [];
  if(country) {
    country.split(',').map(c => c.trim()).forEach(country => {
      const val = countries.find(c => c.value === country);
      if(val) {
        states = [...states, ...(val.states || [])];
        regions = [...regions, ...(val.regions || [])];
      }
    });
  }
  
  return (
    <div>
      <div style={{display:'flex', flexDirection:'row', alignItems:'center', backgroundColor:'white', padding:"24px"}}>
        <BackButton onClick={() => props.history.goBack()} style={{marginRight:16}}/>
        <Text large light style={{flex:1}}>Build a Campaign</Text>
      </div>
      <div style={{padding:"0 24px 40px 24px"}}>
        <div style={{height:80, paddingBottom:40, display:'flex', flexDirection:'row', alignItems:'center'}}>
          <Text huge color="#00b2a8" style={{flex:1}}>{campaign.name}</Text>
        </div>
        
        <div style={{maxWidth:600, margin:'0 auto'}}>
          <Text large light block style={{marginBottom:16}}>Campaign Region</Text>
          
          <div style={{display:'flex', flexDirection:'row', marginBottom:24, width:'100%'}}>
            <MultiSelect
              placeholder="Select Countries"
              label="Country"
              large
              options={countries}
              value={country}
              onChange={setCountry}
              style={{flex:1, margin:'0 16px 0 0'}}
              selectedColor="#00b2a8"
            />
            {regions && regions.length > 0 &&
              <MultiSelect
                label="Region"
                placeholder="Select Regions"
                large
                options={regions}
                value={region}
                onChange={setRegion}
                style={{flex:1, margin:'0 16px 0 0'}}
                selectedColor="#00b2a8"
              />
            }
            {states && states.length > 0 &&
              <MultiSelect
                label="State"
                placeholder="Select States"
                large
                options={states}
                value={state}
                onChange={setState}
                style={{flex:1, margin:'0 16px 0 0'}}
                selectedColor="#00b2a8"
              />
            }
          </div>
          
          <div>
            <Button onClick={save} label="NEXT" small white backgroundColor="#243746"/>
            <Button onClick={skip} label="Skip" small/>
          </div>
        </div>
      </div>
    </div>
  );
}